interface ImageWithFallbackProps {
  src?: string;
  alt: string;
  className?: string;
  icon?: React.ReactNode;
}

function DefaultFallbackIcon() {
  return (
    <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M12 3a2 2 0 012 2c0 .35-.09.68-.24.97L18 9.5l3 1.5-1 2-5-1.5V19a1 1 0 01-1 1h-4a1 1 0 01-1-1v-7.5L4 13l-1-2 3-1.5 4.24-3.53A2 2 0 0110 5a2 2 0 012-2z"
      />
    </svg>
  );
}

export function ImageWithFallback({ src, alt, className = '', icon }: ImageWithFallbackProps) {
  return (
    <div className={`relative overflow-hidden bg-gradient-to-br from-champagne to-champagne-dark ${className}`}>
      <div className="absolute inset-0 flex items-center justify-center text-chocolate-dark/25">
        {icon ?? <DefaultFallbackIcon />}
      </div>
      {src && (
        <img
          src={src}
          alt={alt}
          draggable={false}
          className="absolute inset-0 w-full h-full object-cover"
          onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }}
        />
      )}
    </div>
  );
}
